<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { useAppStore } from './stores/app'
import { useAuthStore } from './stores/auth'

const appStore = useAppStore()
const authStore = useAuthStore()

// Element Plus 组件库文案（分页/表格/弹窗等）跟随应用语言
const { locale } = useI18n()
const elLocale = computed(() => (locale.value.startsWith('zh') ? zhCn : en))

onMounted(() => {
  appStore.initTheme()
})

watch(
  () => authStore.isAuthenticated,
  (isAuthed) => {
    if (isAuthed) {
      appStore.loadLocales()
    }
  },
  { immediate: true }
)
</script>

<template>
  <el-config-provider :locale="elLocale">
    <router-view />
  </el-config-provider>
</template>

<style>
/* Global Resets/Styles */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

/* Smooth transition for theme change - only on layout containers */
html.dark {
  color-scheme: dark;
}

/* Theme-aware layout elements only - avoid global wildcard performance issue */
.el-layout,
.el-main,
.el-aside,
.el-header,
.el-footer,
.app-layout {
  transition: background-color 0.3s, border-color 0.3s;
}

/* Text elements that need theme transition */
.app-text,
.el-card__header,
.el-table th,
.el-table td {
  transition: color 0.3s;
}
</style>
